import React, { useEffect, useState } from 'react';
import { getPermission } from '@/modules/accounts/viewmodels/getPermission';
import { authenticate, getCustomTokenFromSSOServer } from '@/core';
import { getUserByFirebaseId } from '@/modules/users/viewmodels/findFirebaseId';
import { UsersEntity } from '@/domain/entities/users';
import { GetBuOfCurrentUserUsecase } from '@/domain/use-cases/users/getBuOfCurrentUser';
import { UsersRepoIml } from '@/modules/users/adapters/repositories';

export type AppContext = {
  permission: string[];
  userData: UsersEntity;
  buOfUser: string[];
  hasPermission: (permission: string) => boolean;
  hasRole: (role: string) => boolean;
};

export interface AppContextProps {
  children: React.ReactNode;
}

export const AppContext = React.createContext({} as AppContext);

export const AppProvider: React.FC<AppContextProps> = ({ children }) => {
  const { actionGetPermission, permissionData } = getPermission();
  const { userData, actionGetUserByFirebaseId } = getUserByFirebaseId();
  const [buOfUser, setBuOfUser] = useState<string[]>([]);
  const findUser = async () => {
    const customToken = await getCustomTokenFromSSOServer();
    const rs = await authenticate(customToken);
    const { userId } = rs;
    if (userId) {
      actionGetUserByFirebaseId(userId);
    }
  };
  useEffect(() => {
    findUser();
    actionGetPermission();
  }, []);

  const getBuOfUser = async (id: string) => {
    if (!userData.id) {
      throw new Error('User ID is required');
    }
    const usecase = new GetBuOfCurrentUserUsecase(new UsersRepoIml());
    const buOfUser = await usecase.run(id);
    if (buOfUser.businessUnit) {
      setBuOfUser(buOfUser.businessUnit);
    }
  };

  useEffect(() => {
    if (userData.id) {
      getBuOfUser(userData.id);
    }
  }, [userData]);

  const hasPermission = (permission: string) => {
    return permissionData.includes(permission);
  };

  const hasRole = (role: string) => {
    return userData.roles.includes(role);
  };

  return (
    <AppContext.Provider
      value={{
        permission: permissionData,
        userData,
        buOfUser,
        hasPermission,
        hasRole,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
